import React from 'react';
import { NavPages } from '../components/NavPages';
import { Footer } from '../components/Footer';

const Error = () => {
  return (
    <>
      <NavPages />
      <section>
        <div className='container tc'>
          <div className='s-100'></div>
          <div className='w-100 flex aic jcc'>
            <div className='h-40'>
              <h3 className='title c-theme'>Page Not Found</h3>
              <div className='s-50'></div>
              <div className='flex tc jcc'>
                <p>Something went wrong...</p>
              </div>
            </div>
          </div>
          <div className='s-100'></div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export { Error };
